import { createFileRoute } from '@tanstack/react-router';
import { EmployeeLeave } from '@/components/employee/leave';

export const Route = createFileRoute('/(app)/company/leave/$employeeId')({
  component: CompanyLeaveDetailRoute,
});

function CompanyLeaveDetailRoute() {
  const { employeeId } = Route.useParams();
  const employeeIdNum = Number(employeeId);

  return (
    <EmployeeLeave
      employeeId={employeeIdNum}
      showBackButton
      backPath="/company/leave"
    />
  );
}
